import { conf } from '../../configService';
import { listItemType } from './listItemType';

// @see https://schema.org/BreadcrumbList
export const breadcrumbListType = content => {
  if (content.primaryTaxonomy?.entity?.parents) {
    const parents = structuredClone(content.primaryTaxonomy?.entity?.parents);
    parents.unshift(content.primaryTaxonomy.entity);
    const listItems = parents
      .toReversed()
      .map((parent, index) =>
        listItemType(
          index + 1,
          parent.name,
          `https://${conf.canonicalDomain}${parent.hubPage?.url}`
        )
      );

    return {
      '@type': 'BreadcrumbList',
      name: content.title,
      itemListElement: listItems
    };
  }
  return null;
};
